var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrans11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 28,
    r: 27.5,
    fill: "#EDEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4998 26.6197C29.0355 26.6197 30.2803 25.3748 30.2803 23.8391C30.2803 22.3035 29.0355 21.0586 27.4998 21.0586C25.9641 21.0586 24.7192 22.3035 24.7192 23.8391C24.7192 25.3748 25.9641 26.6197 27.4998 26.6197Z",
    fill: "#14A2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0959 16.4402C35.6118 16.4409 34.1511 16.0699 32.8473 15.361L27.5 12.4443L22.1528 15.361C20.849 16.0699 19.3883 16.4409 17.9042 16.4402H13.9473V28.7777C13.9481 31.3295 14.6814 33.8276 16.0601 35.9749C17.4389 38.1223 19.405 39.8287 21.725 40.8916L27.5 43.5554L33.2848 40.9013C35.6048 39.8385 37.571 38.132 38.9497 35.9846C40.3284 33.8373 41.0617 31.3393 41.0625 28.7874V16.4402H37.0959ZM27.5 18.8318C28.4884 18.8318 29.4546 19.1249 30.2764 19.674C31.0981 20.2231 31.7386 21.0036 32.1169 21.9167C32.4951 22.8298 32.5941 23.8346 32.4012 24.804C32.2084 25.7733 31.7325 26.6638 31.0336 27.3626C30.3347 28.0615 29.4443 28.5374 28.475 28.7303C27.5056 28.9231 26.5008 28.8241 25.5877 28.4459C24.6746 28.0677 23.8941 27.4272 23.345 26.6054C22.7959 25.7836 22.5028 24.8174 22.5028 23.8291C22.5054 22.5045 23.0327 21.2349 23.9693 20.2983C24.9059 19.3617 26.1755 18.8344 27.5 18.8318ZM31.9431 34.9416C31.9431 34.3511 31.7085 33.7848 31.291 33.3673C30.8735 32.9497 30.3072 32.7152 29.7167 32.7152H25.2737C24.9826 32.7152 24.6943 32.7725 24.4254 32.8839C24.1564 32.9953 23.9121 33.1586 23.7062 33.3644C23.5004 33.5703 23.3371 33.8146 23.2257 34.0836C23.1143 34.3525 23.057 34.6407 23.057 34.9318H20.8306C20.8306 33.7535 21.2987 32.6234 22.1319 31.7901C22.9652 30.9569 24.0953 30.4888 25.2737 30.4888H29.7167C30.8943 30.4913 32.0229 30.9603 32.8556 31.793C33.6883 32.6256 34.1572 33.7543 34.1598 34.9318L31.9431 34.9416Z",
    fill: "#14A2FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrans11);
export default __webpack_public_path__ + "static/media/trans11.7cb2bde973dc03ae973adcae9e804f79.svg";
export { ForwardRef as ReactComponent };